import { render } from "./registrationStep3.vue?vue&type=template&id=cf7ac174&scoped=true"
import script from "./registrationStep3.vue?vue&type=script&lang=js"
export * from "./registrationStep3.vue?vue&type=script&lang=js"

import "./registrationStep3.vue?vue&type=style&index=0&id=cf7ac174&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf7ac174"]])

export default __exports__